<template>
  <div class="page-container">
    <van-image class="active-value-bg" :src="activeValueBg" width="100%" />
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="not-lev-top-box">
        <van-image class="big-six-bg" :src="BigSixBg" width="100%" />
        <div class="not-lev-cur-value-box">
          <div>当前活跃值</div>
          <div class="value">{{ briskInfo.brisk }}</div>
          <div class="time-bar">完成时间: {{ briskInfo.start_time }} 至 {{ briskInfo.end_time }}</div>
        </div>
      </div>
      <div class="content-box">
        <van-list
          class="list-container"
          v-model:loading="loading"
          :finished="finished"
          :finished-text="finishedText"
          :immediate-check="false"
          @load="getList"
        >
          <div class="list-item-wrp" v-for="item in list" :key="item.rid">
            <div class="list-item-content">
              <div class="active-value-box">
                <div class="active-type">{{ item.brisk_type_msg }}</div>
                <div class="created-time">{{ item.created_time }}</div>
              </div>
              <div class="content">
                <van-image
                  round
                  :width="transPxToRem(20)"
                  :height="transPxToRem(20)"
                  :src="item.avatar_url || 'https://x.jzbull.com/x_dsx_wxadmin/default-head.png'"
                />
                <div class="name">{{ item.operate_name }}</div>
                <RoleTag v-if="item.level" :level="1" :levelName="item.level" />
              </div>
            </div>
            <div class="active-value">+{{ item.brisk }}</div>
          </div>
        </van-list>
        <van-empty
          v-if="list.length == 0 && !loading"
          image-size="240"
          image="https://i.xurl.cn/x_dsx_wxapp/empty/result.png"
          description="暂无数据"
        />
      </div>
    </van-pull-refresh>
  </div>
</template>
<script setup>
import { ref, onMounted, reactive, computed } from 'vue'
import activeValueBg from '@/assets/img/active_value_bg.png'
import RoleTag from '@/components/RoleTag'
import BigSixBg from '@/assets/img/big_six_bg.png'
import { transPxToRem } from '@/utils'
import { userBriskPeriodDetailListApi, getBriskInfoApi } from '@/api/brisk'
import { useRoute } from 'vue-router'

const {
  query: { periodId }
} = useRoute()

const pageParams = reactive({
  page: 1,
  pageSize: 20
})
// const postParams = ref({})
const loading = ref(false)
const finished = ref(false)
const list = ref([])
const finishedText = computed(() => (list.value.length ? '到达地平线' : ''))

const reset = () => {
  finished.value = false
  list.value = []
  pageParams.page = 1
}

const getList = async () => {
  loading.value = true
  try {
    const resData = await userBriskPeriodDetailListApi({ ...pageParams, period_id: periodId })
    list.value.push(...resData.list)
    pageParams.page++
    finished.value = list.value.length === Number(resData.count)
  } catch {
    finished.value = true
  } finally {
    loading.value = false
  }
}

const briskInfo = ref({})

const refreshing = ref(false)
const onRefresh = async () => {
  refreshing.value = true
  try {
    getBriskInfoInfo()
    reset()
    getList()
  } finally {
    refreshing.value = false
  }
}

const getBriskInfoInfo = async () => {
  const resData = await getBriskInfoApi({ period_id: periodId })
  if (resData) {
    briskInfo.value = resData.info
  }
}

onMounted(() => {
  getBriskInfoInfo()
  getList()
})
</script>
<style lang="less" scoped>
.page-container {
  font-size: 14px;
  padding: 16px 0;
  .active-value-bg {
    position: absolute;
    top: 0;
    left: 0;
  }
  .not-lev-top-box {
    position: relative;
    margin: 0 12px;
    .big-six-bg {
      position: absolute;
      z-index: 1;
    }
    .not-lev-cur-value-box {
      background: linear-gradient(90deg, #ffced5 0%, #ff8d9c 100%);
      color: #fff;
      border-radius: 12px;
      font-size: 12px;
      text-align: center;
      padding: 20px 0 30px 0;
      position: relative;
      .value {
        font-size: 36px;
        font-weight: 800;
        margin: 12px 0;
        line-height: 36px;
      }
      .time-bar {
        height: 32px;
        line-height: 32px;
        background: #fff6;
        bottom: 0;
        position: absolute;
        width: 100%;
      }
    }
  }
  .content-box {
    border-radius: 8px;
    overflow: hidden;
    margin-top: 12px;
    .list-item-wrp {
      padding: 16px;
      margin: 12px;
      background: #ffffff;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .list-item-content {
        .active-value-box {
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          .active-type {
            color: #222222;
            font-size: 16px;
            font-weight: 500;
            color: #222222;
            line-height: 22px;
            margin-right: 5px;
          }
          .created-time {
            font-size: 12px;
            color: #999;
          }
        }
        .content {
          display: flex;
          align-items: center;
          .name {
            font-size: 12px;
            line-height: 12px;
            color: #999;
            margin-left: 5px;
          }
        }
      }
      .active-value {
        font-weight: 800;
        font-size: 18px;
      }
    }
  }
}
</style>
